// extracted by mini-css-extract-plugin
export default {"description":"ReferralModal-module__description--TycQP","field":"ReferralModal-module__field--qv7iq"};